import React, { useEffect } from "react";
import eye from "../../assets/icons/eye.svg";
import eyeSlash from "../../assets/icons/eye-off.svg";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../stores/auth";
import { showToastError, showToastSuccess } from "../../services/toast";
import { setPasswordClient } from "../../api/clientPortal";
import { verifyToken } from "../../api/login";
import {
  AuthCopyright,
  AuthField,
  AuthFooterLink,
  AuthShell,
  AuthSubmit,
  PasswordToggle,
} from "../../components/ui/page/AuthShell";

const SetPassword = () => {
  const navigate = useNavigate();
  // Store
  const {
    password,
    setPassword,
    verifyPassword,
    setVerifyPassword,
    showPassword,
    setShowPassword,
    reset,
  } = useAuthStore();
  const [cgu, setCgu] = React.useState(false);

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      verifyToken(token)
        .then(() => {
          console.log("Token verified");
        })
        .catch((err) => {
          console.log(err);
          navigate("/");
        });
    }
  }, [token]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!cgu) {
      showToastError("Veuillez accepter les CGU.");
      return;
    }
    if (password !== verifyPassword) {
      showToastError("Les mots de passe doivent être identiques.");
      return;
    }
    if (verifyPassword.length < 8) {
      showToastError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    } else {
      if (token) {
        setPasswordClient(verifyPassword, token)
          .then((response) => {
            if (response?.status === 200) {
              showToastSuccess("Le mot de passe a bien été réinitialisé !");
              navigate("/");
              reset();
            }
          })
          .catch((err) => {
            if (
              err.response.data.error ===
              "Password can't contain personal information"
            ) {
              showToastError(
                "Votre mot de passe ne peut pas contenir d'informations personnelles",
              );
              return;
            } else if (
              err.response.data.error ===
              "Password must contain at least one uppercase letter, one lowercase letter, one number and one symbol"
            ) {
              showToastError(
                "Votre mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un symbole",
              );
              return;
            } else {
              showToastError(err.response.data.message);
            }
          });
      } else {
        showToastError("Token is missing.");
      }
    }
  };

  const passwordToggle = (
    <PasswordToggle
      visible={showPassword}
      onToggle={() => setShowPassword(!showPassword)}
      icon={showPassword ? eye : eyeSlash}
    />
  );

  return (
    <AuthShell
      eyebrow="Bienvenue"
      headline="Activez votre accès"
      description="Définissez votre mot de passe pour accéder à votre espace client."
      title="Définir votre mot de passe"
      subtitle="Ce mot de passe vous servira à vous connecter."
      footer={
        <>
          <AuthFooterLink onClick={() => navigate("/cgu")}>CGU</AuthFooterLink>
          <span aria-hidden="true" className="text-slate-300">
            •
          </span>
          <AuthCopyright />
        </>
      }
    >
      <form onSubmit={handleSubmit} className="mt-7 flex flex-col gap-4">
        <AuthField
          label="Mot de passe"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={setPassword}
          required
          autoComplete="new-password"
          trailing={passwordToggle}
        />

        <AuthField
          label="Vérification mot de passe"
          type={showPassword ? "text" : "password"}
          value={verifyPassword}
          onChange={setVerifyPassword}
          required
          autoComplete="new-password"
          trailing={passwordToggle}
        />

        <label className="flex cursor-pointer items-center gap-2.5">
          <input
            type="checkbox"
            checked={cgu}
            onChange={(e) => setCgu(e.target.checked)}
            className="size-4 cursor-pointer rounded border-slate-300 accent-indigo-600 focus:ring-2 focus:ring-indigo-200"
          />
          <span className="font-Nunito text-sm text-slate-600">
            J'accepte les conditions générales d'utilisation
          </span>
        </label>

        <AuthSubmit>Valider</AuthSubmit>
      </form>
    </AuthShell>
  );
};

export default SetPassword;
